import { Component } from '@angular/core';

@Component({
  selector: 'h5-wechat-entry',
  templateUrl: './wechat-entry.component.html',
  styleUrls: ['./wechat-entry.component.css']
})
export class WechatEntryComponent {

}
